/**
 * State colors for charts and tables for HCM
 */
export enum HCM_STATE_COLORS {
  'demora-operativa' = '#ff9900',
  mantenimiento = '#707070',
  'no-operativo' = '#5D9CEC',
  operativo = '#22d983',
  red = '#ed5f5f',
  green = '#22d983',
  gray = '#707070',
  default = '#707070'
}
